var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AfterViewInit, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { DomainService } from 'app/services/domain.service';
import { FieldMappingService, LayerCategory } from 'app/services/field-mapping.service';
import { FloatPopupService } from 'app/services/float-popup.service';
import { JstsService } from 'app/services/jsts.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { MainDataService } from 'app/services/main-data.service';
import { MapSharedService } from 'app/services/map-shared.service';
import { ToastrService } from 'ngx-toastr';
import { Feature } from 'ol';
import WKT from 'ol/format/WKT';
import { LineString, Point } from 'ol/geom';
import { LayerService } from 'app/services/layer.service';
import { GfoService } from 'app/services/gfo.service';
import { AppinfoService } from 'app/services/appinfo.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { EditService } from 'app/services/edit.service';
import { UserService } from 'app/services/user.service';
import { AgencyInfoService } from 'app/services/agency-info.service';
import { EditFeatureService } from 'app/services/edit-feature.service';
;
var AddressManageComponent = /** @class */ (function () {
    function AddressManageComponent(document, elemRef, toastr, activityService, agencyInfoService, appinfoService, attrIndexService, commonService, domainService, editService, editFeatureService, fieldMappingService, floatPopupService, gfoService, jstsService, layerService, mainDataService, mapService, mapLayerService, mapSharedService, qcService, userService) {
        var _this = this;
        this.document = document;
        this.elemRef = elemRef;
        this.toastr = toastr;
        this.activityService = activityService;
        this.agencyInfoService = agencyInfoService;
        this.appinfoService = appinfoService;
        this.attrIndexService = attrIndexService;
        this.commonService = commonService;
        this.domainService = domainService;
        this.editService = editService;
        this.editFeatureService = editFeatureService;
        this.fieldMappingService = fieldMappingService;
        this.floatPopupService = floatPopupService;
        this.gfoService = gfoService;
        this.jstsService = jstsService;
        this.layerService = layerService;
        this.mainDataService = mainDataService;
        this.mapService = mapService;
        this.mapLayerService = mapLayerService;
        this.mapSharedService = mapSharedService;
        this.qcService = qcService;
        this.userService = userService;
        this.actionList = [{
                action: 'adhoc',
                label: 'Ad-hoc'
            }, {
                action: 'stacked',
                label: 'Stacked'
            }, {
                action: 'sequenced',
                label: 'Sequenced'
            }];
        this.stepNum = 1;
        this.step1 = {
            num: 1,
            label: 'Select a mode of placement',
            prop: 'action'
        };
        this.adhocSteps = [
            {
                num: 2,
                label: '',
                prop: 'placeAddress'
            }, {
                num: 3,
                label: 'Pick a centerline',
                prop: 'pickLine'
            }, {
                num: 4,
                label: 'Enter address number or select point of ingress',
                prop: 'confirmLabel'
            }
        ];
        this.sequenceSteps = [{
                num: 2,
                label: 'Select a road centerline.',
                prop: 'selectCenterline'
            }, {
                num: 3,
                label: 'Address number configuration',
                prop: 'addressNum'
            }, {
                num: 4,
                label: 'Place addresses in ordered sequence (double click to end)',
                prop: 'placeAddress'
            }];
        this.stackSteps = [
            {
                num: 2,
                label: 'Sub-address Identification',
                prop: 'subAddress'
            }, {
                num: 3,
                label: '',
                prop: 'placeAddress'
            }, {
                num: 4,
                label: 'Select a road centerline.',
                prop: 'selectCenterline'
            }
        ];
        this.assignmentTypes = [
            {
                value: 'interpolated',
                label: 'Interpolated'
            },
            {
                value: 'manual',
                label: 'Manual'
            }
        ];
        this.unitPerMile = 500;
        this.unitPrefix = '';
        this.unitPostfix = '';
        this.showAddressNumInput = false;
        this.containerHeight = 'unset';
        this.addressNumElemId = 'addressNumInput';
        // selectedRecord;
        // currentList: any[] = [];
        // columns: TableColumn[];
        // domainsByColumn: {
        // 	[prop: string]: GivColumnDomain;
        // }
        // editable: boolean;
        // selectLineLabel = 'Select a road centerline.';
        // assignmentLabel = 'Set assignment type';
        this.linePropsById = {};
        // adhoc
        this.addrLinePairs = [];
        // stack
        this.addressList = [];
        this.hintLayerName = 'addressNumberHintLayer';
        this.pickStackLine = function (addrFeats) {
            var lineLayer = _this.map.addedLayers[_this.mapLayerService.addressLineLayerName];
            _this.mapService.startPickOnMap(_this.map, _this.lineLayerNames, function (result) { return __awaiter(_this, void 0, void 0, function () {
                var lineFeat, roadId, roadAttrs, pointFeat, coord, info, step3;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            lineFeat = result.feat;
                            if (!lineFeat) {
                                return [2 /*return*/];
                            }
                            roadId = lineFeat.getId();
                            return [4 /*yield*/, this.getCenterlineInfo(roadId)];
                        case 1:
                            roadAttrs = _a.sent();
                            if (!this.checkCenterline(roadAttrs)) {
                                return [2 /*return*/];
                            }
                            this.selectedLineStack = lineFeat;
                            lineLayer.getSource().addFeature(lineFeat);
                            pointFeat = addrFeats[0];
                            coord = pointFeat.getGeometry().getCoordinates();
                            info = this.mapService.getPointSideToLine(this.selectedLineStack.getGeometry(), coord);
                            addrFeats.forEach(function (f) { return _this.carryOverRoadAttrs(f, info.side, _this.selectedLineStack); });
                            this.mapService.endPickOnMap(this.map);
                            this.stepNum = 3;
                            step3 = this.stackSteps.find(function (i) { return i.prop === 'placeAddress'; });
                            step3.label = 'Place another stacked address';
                            this.placeStackAddresses();
                            return [2 /*return*/];
                    }
                });
            }); });
        };
    }
    AddressManageComponent.prototype.close = function () {
        this.cancel();
    };
    AddressManageComponent.prototype.cancel = function () {
        this.floatPopupService.closePopup(AddressManageComponent);
        this.removeAll();
    };
    AddressManageComponent.prototype.apply = function () {
        var _this = this;
        // Add cards
        var layer = this.map.addedLayers[this.mapLayerService.addressManageLayerName];
        var recList = [];
        layer.getSource().getFeatures().forEach(function (feat) {
            var rec = {};
            rec[_this.uuidCol] = feat.getId();
            rec[_this.attrIndexService.isNewDataKey] = true;
            rec[_this.attrIndexService.isEditedKey] = true;
            // Transfer latlong
            var coord = feat.getGeometry().getCoordinates();
            _this.mapSharedService.transformPointToLatlong(coord, rec);
            // const latlong = transform(coord, 'EPSG:3857', 'EPSG:4326');
            // const precision = 7;
            // rec[this.attrIndexService.addrLatitudeCol] = Number(latlong[1].toFixed(precision));
            // rec[this.attrIndexService.addrLongitudeCol] = Number(latlong[0].toFixed(precision));
            // set geom
            var wktFormat = new WKT();
            var wktStr = wktFormat.writeGeometry(feat.getGeometry());
            rec[_this.attrIndexService.geomColManual] = wktStr;
            Object.keys(feat.getProperties()).forEach(function (k) {
                if (k.toLowerCase() !== 'geometry') {
                    rec[k] = feat.getProperties()[k];
                }
            });
            recList.push(rec);
        });
        // Add to data layer
        var dataLayer = this.map.addedLayers[this.mapLayerService.dataLayerName];
        dataLayer.getSource().addFeatures(layer.getSource().getFeatures());
        this.mainDataService.addDataToStoredRecords(recList, this.uuidCol, 'replace');
        var editedIds = this.activityService.editRecordListBS.getValue().ids.concat(recList.map(function (rec) { return rec[_this.uuidCol]; }));
        this.activityService.editRecordListBS.next({
            ids: editedIds
        });
        this.activityService.changeTabSubject.next({
            tabKey: 'data'
        });
        this.floatPopupService.closePopup(AddressManageComponent);
    };
    AddressManageComponent.prototype.checkApplyDisabled = function () {
        this.containerHeight = 'unset';
        switch (this.action) {
            case 'adhoc':
                this.containerHeight = '290px';
                return !this.addrLinePairs.length;
            case 'sequenced':
                return this.stepNum < 4 || !this.addressList.length;
            case 'stacked':
                return !this.addressList.length;
            default:
                return true;
        }
    };
    AddressManageComponent.prototype.selectAction = function () {
        this.reset();
        this.stepNum = this.step1.num + 1;
        switch (this.action) {
            case 'adhoc':
                var step2 = this.adhocSteps.find(function (i) { return i.prop === 'placeAddress'; });
                step2.label = 'Place An Address Point';
                this.startPlaceAdhoc();
                break;
            case 'stacked':
                var step3 = this.stackSteps.find(function (i) { return i.prop === 'placeAddress'; });
                step3.label = 'Place stacked address on the map';
                break;
            case 'sequenced':
                this.startPickLine();
                break;
        }
    };
    AddressManageComponent.prototype.reset = function () {
        this.addressList = [];
        // adhoc
        // this.assignmentType = null;
        // sequence
        // this.startAddressNum = null;
        this.incrementBy = null;
        // this.unitPerMile = null;
        // stack
        this.numOfStackedAddress = null;
        // this.stackAssignedAddress = null;
        this.stackBuilding = null;
        this.stackStartFloor = null;
        this.stackHeightPerFloor = null;
        this.stackStartElevation = null;
        this.stackUnitIncrement = null;
        this.stackStartUnit = null;
        this.unitPostfix = '';
        this.unitPrefix = '';
        this.addressNumInput = null;
        if (this.selectedLine) {
            this.selectedLine = null;
        }
        this.mapService.endPickOnMap(this.map);
        this.removeAddressNumHint();
        var lineLayer = this.map.addedLayers[this.mapLayerService.addressLineLayerName];
        lineLayer.getSource().clear();
        var addrLayer = this.map.addedLayers[this.mapLayerService.addressManageLayerName];
        addrLayer.getSource().clear();
    };
    // Sequence
    AddressManageComponent.prototype.startPickLine = function () {
        var _this = this;
        // this.mainDataService.addressManageHintBS.next({
        // 	action: this.action,
        // 	message: this.selectLineMessage
        // });
        this.mapService.startPickOnMap(this.map, this.lineLayerNames, function (result) { return __awaiter(_this, void 0, void 0, function () {
            var line, lineLayer, roadId, filter, gfo, rsp, roadAttrs, roadAddrRangeLeft, roadAddrRangeRight, qaNotes;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        line = result.feat;
                        this.selectedLine = line;
                        if (!line) return [3 /*break*/, 3];
                        lineLayer = this.map.addedLayers[this.mapLayerService.addressLineLayerName];
                        lineLayer.getSource().addFeature(line);
                        roadId = this.selectedLine.getId();
                        if (!!this.linePropsById[roadId]) return [3 /*break*/, 2];
                        filter = this.gfoService.getFilter(this.attrIndexService.rcUuidCol, this.appinfoService.filterOperators.eq.name, roadId);
                        gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
                        return [4 /*yield*/, this.qcService.getQcFeatureReport(this.centerlineLayerId, null, gfo)];
                    case 1:
                        rsp = _a.sent();
                        if (rsp.data && rsp.data[0]) {
                            this.linePropsById[roadId] = rsp.data[0];
                        }
                        else {
                            this.linePropsById[roadId] = {};
                            this.toastr.warning('Can not find centerline attributes.');
                        }
                        _a.label = 2;
                    case 2:
                        roadAttrs = this.linePropsById[roadId];
                        roadAddrRangeLeft = [roadAttrs[this.attrIndexService.fromAddrLeftColName], roadAttrs[this.attrIndexService.toAddrLeftColName]];
                        roadAddrRangeRight = [roadAttrs[this.attrIndexService.fromAddrRightColName], roadAttrs[this.attrIndexService.toAddrRightColName]];
                        qaNotes = roadAttrs[this.attrIndexService.qaNotesColName];
                        if (qaNotes && qaNotes.length && qaNotes.find(function (i) { return ['ADR'].indexOf(i.cd) > -1; })) {
                            this.toastr.info('Invalid centerline.');
                            return [2 /*return*/];
                        }
                        if ((!roadAddrRangeLeft || roadAddrRangeLeft[0] === roadAddrRangeLeft[1]) && (!roadAddrRangeRight || roadAddrRangeRight[0] === roadAddrRangeRight[1])) {
                            this.toastr.info('Address range data is not completed on this centerline.');
                            return [2 /*return*/];
                        }
                        setTimeout(function () {
                            _this.mapService.endPickOnMap(_this.map);
                            _this.stepNum++;
                        }, 500); // setTimeout so that selectFromMapCondition can kick in
                        return [3 /*break*/, 4];
                    case 3:
                        this.toastr.info('Centerline not found.');
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    };
    AddressManageComponent.prototype.onChangeSequenceType = function () {
        this.checkSequenceStep3();
    };
    AddressManageComponent.prototype.onChangeStartAddress = function () {
        this.checkSequenceStep3();
    };
    AddressManageComponent.prototype.onChangeIncrementBy = function () {
        if (this.incrementBy && this.sequenceType !== 'incrementBy') {
            this.sequenceType = 'incrementBy';
        }
        this.checkSequenceStep3();
    };
    AddressManageComponent.prototype.onChangeUnitPerMile = function () {
        if (this.unitPerMile && this.sequenceType !== 'unitPerMile') {
            this.sequenceType = 'unitPerMile';
        }
        this.checkSequenceStep3();
    };
    AddressManageComponent.prototype.checkSequenceStep3 = function () {
        var goNext = false;
        if (this.sequenceType) {
            if (this.sequenceType === 'incrementBy' && (this.incrementBy || this.incrementBy === 0)) { // && (this.startAddressNum || this.startAddressNum === 0)
                goNext = true;
            }
            else if (this.sequenceType === 'unitPerMile' && (this.unitPerMile || this.unitPerMile === 0)) {
                goNext = true;
            }
        }
        if (goNext && this.stepNum === 3) {
            this.stepNum++;
            this.placeAddresses();
        }
        else if (!goNext && this.stepNum > 3) {
            this.stepNum = 3;
            this.mapService.endPickOnMap(this.map);
            this.removeAddressNumHint();
        }
    };
    AddressManageComponent.prototype.onChangeStackAddrNum = function () {
        this.checkStackStep2();
    };
    AddressManageComponent.prototype.onChangeStackBuilding = function () {
        // this.checkStackStep2();
    };
    AddressManageComponent.prototype.onChangeStackFloor = function () {
        this.checkStackStep2();
    };
    AddressManageComponent.prototype.onChangeNumOfStackedAddress = function () {
        this.checkStackStep2();
    };
    AddressManageComponent.prototype.onChangeStackUnit = function () { };
    AddressManageComponent.prototype.onChangeStackUnitIncrement = function () { };
    AddressManageComponent.prototype.onChangeStackUnitPrefix = function () { };
    AddressManageComponent.prototype.onChangeStackUnitPostfix = function () { };
    AddressManageComponent.prototype.onChangeStackElevation = function () { };
    AddressManageComponent.prototype.onChangeHeightPerFloor = function () { };
    AddressManageComponent.prototype.checkStackStep2 = function () {
        if ((this.stackStartFloor || this.stackStartFloor === 0) && this.numOfStackedAddress >= 1 && (this.stackAddrNum || this.stackAddrNum === 0)) {
            if (this.stepNum === 2) {
                this.stepNum++;
                this.placeStackAddresses();
            }
        }
        else {
            if (this.stepNum > 2) {
                this.stepNum = 2;
                this.mapService.endPickOnMap(this.map);
                this.removeAddressNumHint();
            }
        }
    };
    AddressManageComponent.prototype.positionAddrInput = function (pixel, onLoseFocus, onEnter) {
        var inputElem = this.elemRef.nativeElement.querySelector("#" + this.addressNumElemId + " input");
        inputElem.focus();
        var elem = this.elemRef.nativeElement.querySelector('#' + this.addressNumElemId);
        var holderElem = this.document.querySelector('app-address-manage');
        var mapElem = this.document.querySelector('.map-container');
        var left = pixel[0] - (holderElem.getBoundingClientRect().left - mapElem.getBoundingClientRect().left) + 5;
        var top = pixel[1] + (mapElem.getBoundingClientRect().top - holderElem.getBoundingClientRect().top) + 10;
        elem.style.top = top + 'px';
        elem.style.left = left + 'px';
        var losefocusCallback = function (e) {
            if (onLoseFocus) {
                onLoseFocus();
            }
            inputElem.removeEventListener('keypress', keyPressCallback);
            inputElem.removeEventListener('focusout', losefocusCallback);
        };
        var keyPressCallback = function (e) {
            if (e.key === 'Enter') {
                if (onEnter) {
                    console.log('aaa');
                    onEnter();
                }
                inputElem.removeEventListener('focusout', losefocusCallback);
                inputElem.removeEventListener('keypress', keyPressCallback);
            }
        };
        inputElem.addEventListener('keypress', keyPressCallback);
        inputElem.addEventListener('focusout', losefocusCallback);
        return {
            elem: elem,
            inputElem: inputElem
        };
    };
    // Sequence
    AddressManageComponent.prototype.placeAddresses = function () {
        var _this = this;
        var roadId = this.selectedLine.getId();
        // const parser = this.jstsService.getJstsParser();
        // const jstsGeomRoad = parser.read(this.selectedLine.getGeometry());
        var roadAttrs = this.linePropsById[roadId];
        var roadAddrRangeLeft = [roadAttrs[this.attrIndexService.fromAddrLeftColName], roadAttrs[this.attrIndexService.toAddrLeftColName]];
        var roadAddrRangeRight = [roadAttrs[this.attrIndexService.fromAddrRightColName], roadAttrs[this.attrIndexService.toAddrRightColName]];
        // Sequence - incrementBy
        var addrNum_sequence; // = this.startAddressNum;
        var byUnitAddrNumOffset;
        this.addAddressNumHint(this.selectedLine);
        this.mapService.startPickOnMap(this.map, [], function (result) {
            var coord = result.location;
            // Calculate side
            var info = _this.mapService.getPointSideToLine(_this.selectedLine.getGeometry(), coord);
            // const info = await this.mapService.getPointPositionToLine(this.centerlineLayerId, roadId, coord);
            var addrRange;
            var parity;
            if (info.side === 'left') {
                addrRange = roadAddrRangeLeft;
                parity = roadAttrs[_this.attrIndexService.parityLeftColName];
            }
            else {
                addrRange = roadAddrRangeRight;
                parity = roadAttrs[_this.attrIndexService.parityRightColName];
            }
            // if (!addrRange || addrRange[1] === addrRange[0]) {
            if (!_this.editFeatureService.checkRoadRangeValid(addrRange)) {
                _this.toastr.warning('Address range not found.');
                return;
            }
            //
            var pointFeat = _this.addNewPointToMap(coord);
            _this.addressList.push(pointFeat);
            // const jstsGeomPoint = parser.read(new Point(coord));
            // const distanceOp = new jstsOperation.distance.DistanceOp(jstsGeomRoad, jstsGeomPoint);
            // const points = distanceOp.nearestPoints();
            var pointOnLine = _this.selectedLine.getGeometry().getClosestPoint(coord);
            console.log(pointOnLine);
            _this.carryOverRoadAttrs(pointFeat, info.side);
            var nearestPointOnRoad = pointOnLine;
            if (_this.action === 'adhoc') {
                _this.showAddressNumInput = true;
                var addrNum = _this.editFeatureService.getAddressNumInterpolate(nearestPointOnRoad, _this.selectedLine, addrRange, parity);
                _this.addressNumInput = addrNum;
                setTimeout(function () {
                    var pixel = result.e.pixel;
                    var setProp = function () {
                        var props = {};
                        props[_this.attrIndexService.addrAddNumCol] = _this.addressNumInput;
                        pointFeat.setProperties(props);
                        _this.showAddressNumInput = false;
                        if (_this.addressNumInput < addrRange[0] || _this.addressNumInput > addrRange[1]) {
                            _this.toastr.warning('Address number out of range');
                        }
                    };
                    _this.positionAddrInput(pixel, setProp, setProp);
                    // const onClick = () => {
                    // 	setProp();
                    // }
                    // const onKeypress = e => {
                    // 	if (e.key === 'Enter') {
                    // 		setProp();
                    // 	}
                    // }
                });
            }
            else if (_this.action === 'sequenced') {
                if (!addrNum_sequence && addrNum_sequence !== 0) {
                    _this.showAddressNumInput = true;
                    var addrNum = _this.editFeatureService.getAddressNumInterpolate(nearestPointOnRoad, _this.selectedLine, addrRange, parity);
                    _this.addressNumInput = addrNum;
                    setTimeout(function () {
                        var pixel = result.e.pixel;
                        var setProp = function () {
                            addrNum_sequence = _this.addressNumInput;
                            var props = {};
                            props[_this.attrIndexService.addrAddNumCol] = _this.addressNumInput;
                            pointFeat.setProperties(props);
                            _this.showAddressNumInput = false;
                            // For unitPerMile use // For the first picked point
                            if (!byUnitAddrNumOffset && byUnitAddrNumOffset !== 0) {
                                var splitLine = _this.mapSharedService.getSplitLineByPoint(_this.selectedLine, nearestPointOnRoad).first;
                                // Convert meter to mile and calculate increased address number
                                var deltaAddrNumber = splitLine.getLength() * 0.000621371192 * _this.unitPerMile;
                                var addrNumByUnit = addrRange[0] + deltaAddrNumber;
                                byUnitAddrNumOffset = addrNumByUnit - _this.addressNumInput; // this.startAddressNum;
                            }
                            if (_this.sequenceType === 'incrementBy') {
                                addrNum_sequence += _this.incrementBy;
                            }
                            if (_this.addressNumInput < addrRange[0] || _this.addressNumInput > addrRange[1]) {
                                _this.toastr.warning('Address number out of range');
                            }
                        };
                        _this.positionAddrInput(pixel, setProp, setProp);
                    });
                }
                if (_this.sequenceType === 'incrementBy') {
                    addrNum_sequence = Number(addrNum_sequence.toFixed(0));
                    var props = {};
                    props[_this.attrIndexService.addrAddNumCol] = addrNum_sequence;
                    pointFeat.setProperties(props);
                    addrNum_sequence += _this.incrementBy;
                }
                else if (_this.sequenceType === 'unitPerMile') {
                    if (byUnitAddrNumOffset || byUnitAddrNumOffset === 0) {
                        var splitLine = _this.mapSharedService.getSplitLineByPoint(_this.selectedLine, nearestPointOnRoad).first;
                        // Convert meter to mile and calculate increased address number
                        var deltaAddrNumber = splitLine.getLength() * 0.000621371192 * _this.unitPerMile;
                        var addrNumByUnit = addrRange[0] + deltaAddrNumber;
                        addrNumByUnit = addrNumByUnit - byUnitAddrNumOffset;
                        addrNumByUnit = _this.editFeatureService.roundAddressNumByParity(addrNumByUnit, parity); // Number(addrNum.toFixed(0));
                        var props = {};
                        props[_this.attrIndexService.addrAddNumCol] = addrNumByUnit;
                        pointFeat.setProperties(props);
                    }
                }
            }
            else if (_this.action === 'stacked') {
                _this.showAddressNumInput = true;
                var addrNum = _this.editFeatureService.getAddressNumInterpolate(nearestPointOnRoad, _this.selectedLine, addrRange, parity);
                _this.addressNumInput = addrNum;
                _this.mapService.endPickOnMap(_this.map);
                _this.removeAddressNumHint();
                setTimeout(function () {
                    var pixel = result.e.pixel;
                    var setProp = function () {
                        var props = {};
                        props[_this.attrIndexService.addrAddNumCol] = _this.addressNumInput;
                        pointFeat.setProperties(props);
                        var inputElem = _this.elemRef.nativeElement.querySelector("#" + _this.addressNumElemId + " input");
                        inputElem;
                        _this.showAddressNumInput = false;
                        if (_this.addressNumInput < addrRange[0] || _this.addressNumInput > addrRange[1]) {
                            _this.toastr.warning('Address number out of range');
                        }
                        if (_this.numOfStackedAddress > 1) {
                            var sameLocation = '123';
                            props[_this.attrIndexService.sameLocationKey] = sameLocation;
                            props[_this.attrIndexService.addrAddNumCol] = _this.addressNumInput;
                            if (_this.stackBuilding) {
                                props[_this.attrIndexService.addrBuildingCol] = _this.stackBuilding;
                            }
                            var floor = _this.stackStartFloor;
                            var unit = _this.stackStartUnit || null;
                            var elevation = _this.stackStartElevation || null;
                            props[_this.attrIndexService.addrFloorCol] = floor;
                            if (unit !== null) {
                                props[_this.attrIndexService.addrUnitCol] = _this.unitPrefix + unit + _this.unitPostfix;
                            }
                            if (elevation !== null) {
                                props[_this.attrIndexService.addrElevationCol] = elevation;
                            }
                            pointFeat.setProperties(props);
                            for (var i = 1; i < _this.numOfStackedAddress; i++) {
                                var stackFeat = _this.addNewPointToMap(coord);
                                floor++;
                                props[_this.attrIndexService.addrFloorCol] = floor;
                                //
                                if (unit !== null) {
                                    unit += _this.stackUnitIncrement ? _this.stackUnitIncrement : 0;
                                    // props[this.attrIndexService.addrUnitCol] = (this.unitPrefix ? this.unitPrefix +  ' ' : '') + unit + (this.unitPostfix ? ' ' + this.unitPostfix : '');
                                    props[_this.attrIndexService.addrUnitCol] = _this.unitPrefix + unit + _this.unitPostfix;
                                }
                                if (elevation !== null) {
                                    elevation += _this.stackHeightPerFloor ? _this.stackHeightPerFloor : 0;
                                    props[_this.attrIndexService.addrElevationCol] = elevation;
                                }
                                stackFeat.setProperties(props);
                                _this.addressList.push(stackFeat);
                                _this.carryOverRoadAttrs(stackFeat, info.side);
                            }
                        }
                        _this.stepNum++;
                    };
                    _this.positionAddrInput(pixel, setProp, setProp);
                });
            }
        });
        this.mapService.addMapDblclickStop(this.map, function () {
            _this.mapService.endPickOnMap(_this.map);
            _this.stepNum++;
            _this.removeAddressNumHint();
        });
    };
    AddressManageComponent.prototype.getCenterlineInfo = function (roadId) {
        return __awaiter(this, void 0, void 0, function () {
            var filter, gfo, rsp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.linePropsById[roadId]) return [3 /*break*/, 2];
                        filter = this.gfoService.getFilter(this.attrIndexService.rcUuidCol, this.appinfoService.filterOperators.eq.name, roadId);
                        gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
                        return [4 /*yield*/, this.qcService.getQcFeatureReport(this.centerlineLayerId, null, gfo)];
                    case 1:
                        rsp = _a.sent();
                        if (rsp.data && rsp.data[0]) {
                            this.linePropsById[roadId] = rsp.data[0];
                        }
                        else {
                            this.linePropsById[roadId] = {};
                            this.toastr.warning('Can not find centerline attributes.');
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.linePropsById[roadId]];
                }
            });
        });
    };
    AddressManageComponent.prototype.checkCenterline = function (roadAttrs) {
        var roadAddrRangeLeft = [roadAttrs[this.attrIndexService.fromAddrLeftColName], roadAttrs[this.attrIndexService.toAddrLeftColName]];
        var roadAddrRangeRight = [roadAttrs[this.attrIndexService.fromAddrRightColName], roadAttrs[this.attrIndexService.toAddrRightColName]];
        var qaNotes = roadAttrs[this.attrIndexService.qaNotesColName];
        if (qaNotes && qaNotes.length && qaNotes.find(function (i) { return ['ADR'].indexOf(i.cd) > -1; })) {
            this.toastr.info('Invalid centerline.');
            return;
        }
        if ((!roadAddrRangeLeft || roadAddrRangeLeft[0] === roadAddrRangeLeft[1]) && (!roadAddrRangeRight || roadAddrRangeRight[0] === roadAddrRangeRight[1])) {
            this.toastr.info('Address range data is not completed on this centerline.');
            return;
        }
        return true;
    };
    //
    AddressManageComponent.prototype.addAddressNumHint = function (lineFeat, isUpdateInput) {
        var _this = this;
        var layer = this.map.addLayer(this.hintLayerName, {
            style: this.mapLayerService.getAddressHintStyle
        });
        this.onPointermove = function (e) {
            var coord = e.coordinate;
            var pointOnLine = lineFeat.getGeometry().getClosestPoint(coord);
            var pointFeat = new Feature({
                geometry: new Point(pointOnLine)
            });
            var dashFeat = new Feature({
                geometry: new LineString([pointOnLine, coord])
            });
            layer.getSource().clear();
            layer.getSource().addFeature(pointFeat);
            layer.getSource().addFeature(dashFeat);
            //
            if (_this.action !== 'adhoc' && _this.action !== 'stacked') {
                return;
            }
            if (_this.addressNumHintTimeout) {
                clearTimeout(_this.addressNumHintTimeout);
            }
            _this.addressNumHintTimeout = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                var roadId, info, addrRange, parity, roadAttrs, roadAddrRangeLeft, roadAddrRangeRight, rangeValid, addrNum, props;
                return __generator(this, function (_a) {
                    roadId = lineFeat.getId();
                    info = this.mapService.getPointSideToLine(lineFeat.getGeometry(), coord);
                    roadAttrs = this.linePropsById[roadId];
                    roadAddrRangeLeft = [roadAttrs[this.attrIndexService.fromAddrLeftColName], roadAttrs[this.attrIndexService.toAddrLeftColName]];
                    roadAddrRangeRight = [roadAttrs[this.attrIndexService.fromAddrRightColName], roadAttrs[this.attrIndexService.toAddrRightColName]];
                    if (info.side === 'left') {
                        addrRange = roadAddrRangeLeft;
                        parity = roadAttrs[this.attrIndexService.parityLeftColName];
                    }
                    else {
                        addrRange = roadAddrRangeRight;
                        parity = roadAttrs[this.attrIndexService.parityRightColName];
                    }
                    rangeValid = this.editFeatureService.checkRoadRangeValid(addrRange);
                    if (!rangeValid) {
                        this.mapSharedService.changeCursor(this.map.olMap, 'url(assets/css/img/remove-cross-red.png) 7.5 7.5, crosshair');
                        return [2 /*return*/];
                    }
                    else {
                        this.mapSharedService.changeCursor(this.map.olMap, 'crosshair');
                    }
                    addrNum = this.editFeatureService.getAddressNumInterpolate(pointOnLine, lineFeat, addrRange, parity);
                    if (isUpdateInput) {
                        this.addressNumInput = addrNum;
                    }
                    else {
                        props = {};
                        props[this.attrIndexService.addrAddNumCol] = addrNum;
                        pointFeat.setProperties(props);
                    }
                    this.addressNumHintTimeout = null;
                    return [2 /*return*/];
                });
            }); }, 500);
        };
        this.map.olMap.on('pointermove', this.onPointermove);
    };
    AddressManageComponent.prototype.removeAddressNumHint = function () {
        if (this.onPointermove) {
            this.map.removeLayer(this.hintLayerName);
            this.map.olMap.un('pointermove', this.onPointermove);
            this.onPointermove = null;
        }
    };
    AddressManageComponent.prototype.carryOverRoadAttrs = function (feat, side, lineFeat) {
        lineFeat = lineFeat || this.selectedLine;
        if (!lineFeat || !this.centerlineCate) {
            return;
        }
        var lineAttrs = this.linePropsById[lineFeat.getId()];
        this.editFeatureService.carryOverCenterlineAttrsToAddress(lineAttrs, side, this.addressCate, this.centerlineCate, feat);
        // this.addressCate.standardCols.forEach(i => {
        // 	let lineCol: LayerCategoryStandardSchema;
        // 	if (i.transferRclCol) {
        // 		lineCol = this.centerlineCate.standardCols.find(c => c.colName === i.transferRclCol)
        // 	}
        // 	const addrProp = this.addressCate.colPrefix + '_' + i.colName.toLowerCase();
        // 	const prop = {};
        // 	switch (i.transferRclVal) {
        // 		case 'transfer':
        // 			let colName = i.transferRclCol || i.colName;
        // 			lineCol = this.centerlineCate.standardCols.find(c => c.colName === colName)
        // 			break;
        // 		case 'parity':
        // 			let colNameWithSide = i.transferRclCol + (side === 'left' ? '_l' : '_r');
        // 			lineCol = this.centerlineCate.standardCols.find(c => c.colName.toLowerCase() === colNameWithSide.toLowerCase());
        // 			break;
        // 	}
        // 	if (lineCol) {
        // 		const lineColProp = this.centerlineCate.colPrefix + '_' + lineCol.colName.toLowerCase();
        // 		prop[addrProp] = lineAttrs[lineColProp];
        // 	}
        // 	if (i.transferRclVal === 'calc') {
        // 		switch (i.colName.toLowerCase()) {
        // 			case this.attrIndexService.discrepancyAgencyIdStandardLower:
        // 				const discAgencyId = this.userService.customerInfo.discrepancyId;
        // 				prop[addrProp] = discAgencyId;
        // 				break;
        // 			case this.attrIndexService.dateUpdateCol.toLowerCase():
        // 				prop[addrProp] = this.editService.convertDateToStr(new Date())
        // 				break;
        // 			case this.attrIndexService.nguidCol.toLowerCase():
        // 				// const pattern = {
        // 				// 	layerType: this.agencyInfoService.getIsLayerTypeFromNguidPattern(this.userService.customerInfo.nguidPattern)
        // 				// }
        // 				const nguid = this.agencyInfoService.computeNguid(this.addressCate.code)
        // 				prop[addrProp] = nguid;
        // 				break;
        // 			// todo: latitude/longitude
        // 		}
        // 	}
        // 	feat.setProperties(prop);
        // })
    };
    AddressManageComponent.prototype.addNewPointToMap = function (coord) {
        var layerName = this.mapLayerService.addressManageLayerName;
        var layer = this.map.addedLayers[layerName];
        var newPoint = new Feature({
            geometry: new Point(coord)
        });
        layer.getSource().addFeature(newPoint);
        // const rec = this.mainDataService.addNewCard(this.uuidCol);
        // const recId = rec[this.uuidCol];
        // set geom
        var wktFormat = new WKT();
        var wktStr = wktFormat.writeGeometry(newPoint.getGeometry());
        var recId = this.commonService.getRandomId();
        this.mainDataService.setDataAttrs(recId, this.attrIndexService.geomColManual, wktStr);
        newPoint.setId(recId);
        return newPoint;
    };
    AddressManageComponent.prototype.removeAll = function () {
        this.mapService.endPickOnMap(this.map);
        this.removeAddressNumHint();
        if (this.map.addedLayers[this.mapLayerService.addressManageLayerName]) {
            this.map.removeLayer(this.mapLayerService.addressManageLayerName);
        }
        if (this.map.addedLayers[this.mapLayerService.addressLineLayerName]) {
            this.map.removeLayer(this.mapLayerService.addressLineLayerName);
        }
    };
    // Adhoc
    AddressManageComponent.prototype.startPlaceAdhoc = function () {
        var _this = this;
        var addrFeat, lineFeat;
        var coord;
        // Pick Address
        this.mapService.startPickOnMap(this.map, [], function (result) {
            coord = result.location;
            //
            var pointFeat = _this.addNewPointToMap(coord);
            addrFeat = pointFeat;
        }, function () {
            _this.stepNum++;
            // Pick Line
            var lineLayer = _this.map.addedLayers[_this.mapLayerService.addressLineLayerName];
            _this.mapService.startPickOnMap(_this.map, [_this.mapLayerService.bgReferenceLayerName], function (result) { return __awaiter(_this, void 0, void 0, function () {
                var roadId, roadAttrs, addrNum, info, addrRange_1, parity, roadAddrRangeLeft, roadAddrRangeRight, pair;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            lineFeat = result.feat;
                            if (!lineFeat) return [3 /*break*/, 2];
                            roadId = lineFeat.getId();
                            return [4 /*yield*/, this.getCenterlineInfo(roadId)];
                        case 1:
                            roadAttrs = _a.sent();
                            //
                            lineLayer.getSource().addFeature(lineFeat);
                            this.mapService.endPickOnMap(this.map);
                            this.stepNum++;
                            // Label step
                            this.addAddressNumHint(lineFeat, true);
                            this.showAddressNumInput = true;
                            addrNum = null;
                            this.addressNumInput = addrNum;
                            info = this.mapService.getPointSideToLine(lineFeat.getGeometry(), coord);
                            this.carryOverRoadAttrs(addrFeat, info.side, lineFeat);
                            parity = void 0;
                            roadAddrRangeLeft = [roadAttrs[this.attrIndexService.fromAddrLeftColName], roadAttrs[this.attrIndexService.toAddrLeftColName]];
                            roadAddrRangeRight = [roadAttrs[this.attrIndexService.fromAddrRightColName], roadAttrs[this.attrIndexService.toAddrRightColName]];
                            if (info.side === 'left') {
                                addrRange_1 = roadAddrRangeLeft;
                                parity = roadAttrs[this.attrIndexService.parityLeftColName];
                            }
                            else {
                                addrRange_1 = roadAddrRangeRight;
                                parity = roadAttrs[this.attrIndexService.parityRightColName];
                            }
                            setTimeout(function () {
                                var pixel = result.e.pixel;
                                var setProp = function () {
                                    var props = {};
                                    props[_this.attrIndexService.addrAddNumCol] = _this.addressNumInput;
                                    addrFeat.setProperties(props);
                                    _this.showAddressNumInput = false;
                                    _this.removeAddressNumHint();
                                    if (_this.editFeatureService.checkRoadRangeValid(addrRange_1)) {
                                        if (_this.addressNumInput < addrRange_1[0] || _this.addressNumInput > addrRange_1[1]) {
                                            _this.toastr.warning('Address number out of range');
                                        }
                                    }
                                    _this.stepNum = 2;
                                    var step2 = _this.adhocSteps.find(function (i) { return i.prop === 'placeAddress'; });
                                    step2.label = 'Place another address point or Add cards';
                                    _this.startPlaceAdhoc();
                                };
                                _this.positionAddrInput(pixel, setProp, setProp);
                            });
                            pair = {
                                addrFeat: addrFeat,
                                lineFeat: lineFeat
                            };
                            this.addrLinePairs.push(pair);
                            return [3 /*break*/, 3];
                        case 2:
                            this.toastr.info('Centerline not found.');
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
        });
    };
    // Stack
    AddressManageComponent.prototype.placeStackAddresses = function () {
        var _this = this;
        var addrFeats = [];
        this.mapService.startPickOnMap(this.map, [], function (result) {
            var coord = result.location;
            //
            var pointFeat = _this.addNewPointToMap(coord);
            addrFeats.push(pointFeat);
            var setProp = function () {
                var props = {};
                props[_this.attrIndexService.addrAddNumCol] = _this.addressNumInput;
                pointFeat.setProperties(props);
                if (_this.numOfStackedAddress > 1) {
                    var sameLocation = '123';
                    props[_this.attrIndexService.sameLocationKey] = sameLocation;
                    props[_this.attrIndexService.addrAddNumCol] = _this.stackAddrNum;
                    if (_this.stackBuilding) {
                        props[_this.attrIndexService.addrBuildingCol] = _this.stackBuilding;
                    }
                    var floor = _this.stackStartFloor;
                    var unit = _this.stackStartUnit || null;
                    var elevation = _this.stackStartElevation || null;
                    props[_this.attrIndexService.addrFloorCol] = floor;
                    if (unit !== null) {
                        props[_this.attrIndexService.addrUnitCol] = _this.unitPrefix + unit + _this.unitPostfix;
                    }
                    if (elevation !== null) {
                        props[_this.attrIndexService.addrElevationCol] = elevation;
                    }
                    pointFeat.setProperties(props);
                    for (var i = 1; i < _this.numOfStackedAddress; i++) {
                        var stackFeat = _this.addNewPointToMap(coord);
                        floor++;
                        props[_this.attrIndexService.addrFloorCol] = floor;
                        //
                        if (unit !== null) {
                            unit += _this.stackUnitIncrement ? _this.stackUnitIncrement : 0;
                            props[_this.attrIndexService.addrUnitCol] = _this.unitPrefix + unit + _this.unitPostfix;
                        }
                        if (elevation !== null) {
                            elevation += _this.stackHeightPerFloor ? _this.stackHeightPerFloor : 0;
                            props[_this.attrIndexService.addrElevationCol] = elevation;
                        }
                        stackFeat.setProperties(props);
                        addrFeats.push(stackFeat);
                    }
                }
                _this.addressList = _this.addressList.concat(addrFeats);
                (pointFeat);
                _this.stepNum++;
            };
            setProp();
        }, function () { return _this.pickStackLine(addrFeats); });
    };
    AddressManageComponent.prototype.startPlacingAddressLine = function () {
        var _this = this;
        var lineLayer = this.map.addedLayers[this.mapLayerService.addressLineLayerName];
        var addrFeat, lineFeat;
        var count = 0;
        // Add an address
        var start = function () {
            if (count >= 100) {
                return;
            }
            count++;
            _this.mapService.startPickOnMap(_this.map, [], function (result) {
                var coord = result.location;
                //
                var pointFeat = _this.addNewPointToMap(coord);
                addrFeat = pointFeat;
                lineLayer.getSource().clear();
                _this.mapService.addMapDblclickStop(_this.map, function () {
                    _this.mapService.endPickOnMap(_this.map);
                    if (addrFeat && !lineFeat) {
                        var layerName = _this.mapLayerService.addressManageLayerName;
                        var layer = _this.map.addedLayers[layerName];
                        layer.getSource().removeFeature(addrFeat);
                    }
                });
            }, function () {
                // Pick a line
                _this.mapService.startPickOnMap(_this.map, [_this.mapLayerService.bgReferenceLayerName], function (result) { return __awaiter(_this, void 0, void 0, function () {
                    var roadId, filter, gfo, rsp, roadAttrs, pair;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!result.feat) return [3 /*break*/, 3];
                                roadId = result.feat.getId();
                                if (!!this.linePropsById[roadId]) return [3 /*break*/, 2];
                                filter = this.gfoService.getFilter(this.attrIndexService.rcUuidCol, this.appinfoService.filterOperators.eq.name, roadId);
                                gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
                                return [4 /*yield*/, this.qcService.getQcFeatureReport(this.centerlineLayerId, null, gfo)];
                            case 1:
                                rsp = _a.sent();
                                if (rsp.data && rsp.data[0]) {
                                    this.linePropsById[roadId] = rsp.data[0];
                                }
                                else {
                                    this.linePropsById[roadId] = {};
                                    this.toastr.warning('Can not find centerline attributes.');
                                }
                                _a.label = 2;
                            case 2:
                                roadAttrs = this.linePropsById[roadId];
                                lineFeat = result.feat;
                                //
                                lineLayer.getSource().addFeature(lineFeat);
                                pair = {
                                    addrFeat: addrFeat,
                                    lineFeat: lineFeat
                                };
                                this.addrLinePairs.push(pair);
                                lineFeat = null;
                                addrFeat = null;
                                return [3 /*break*/, 4];
                            case 3:
                                this.toastr.info('Centerline not found.');
                                _a.label = 4;
                            case 4: return [2 /*return*/];
                        }
                    });
                }); }, start);
            });
        };
        start();
    };
    AddressManageComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var centerlineLayerCate, stdSchema, err_1, addrCate, stdSchema, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.uuidCol = this.attrIndexService.addrGlobalId;
                        this.lineLayerNames = [this.mapLayerService.bgReferenceLayerName];
                        this.centerlineLayerId = this.layerService.layerListBS.getValue().layers.find(function (l) { return l.category.code === _this.attrIndexService.cateCodeCenterline; }).id;
                        centerlineLayerCate = this.appinfoService.layerTypeList.find(function (i) { return i.code === _this.attrIndexService.cateCodeCenterline; });
                        if (!!centerlineLayerCate.standardCols) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fieldMappingService.getStandardSchema(centerlineLayerCate.id)];
                    case 2:
                        stdSchema = _a.sent();
                        centerlineLayerCate.standardCols = stdSchema;
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.toastr.info('Centerline layer schema not found.');
                        console.log(err_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.centerlineCate = centerlineLayerCate;
                        addrCate = this.appinfoService.layerTypeList.find(function (i) { return i.code === _this.attrIndexService.cateCodeAddress; });
                        if (!!addrCate.standardCols) return [3 /*break*/, 8];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.fieldMappingService.getStandardSchema(addrCate.id)];
                    case 6:
                        stdSchema = _a.sent();
                        addrCate.standardCols = stdSchema;
                        return [3 /*break*/, 8];
                    case 7:
                        err_2 = _a.sent();
                        this.toastr.info('Address layer schema not found.');
                        console.log(err_2);
                        return [3 /*break*/, 8];
                    case 8:
                        this.addressCate = addrCate;
                        return [2 /*return*/];
                }
            });
        });
    };
    AddressManageComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.mapSub = this.mapService.mapBS.subscribe(function (data) {
            _this.map = data;
            if (!_this.map.addedLayers[_this.mapLayerService.addressManageLayerName]) {
                _this.mapLayerService.addAddressManageLayer(_this.map);
            }
            if (!_this.map.addedLayers[_this.mapLayerService.addressLineLayerName]) {
                _this.mapLayerService.addAddressLineLayer(_this.map);
            }
        });
        // this.editableSub = this.mainDataService.dataEditableBS.subscribe(data => {
        // 	this.editable = data.editable;
        // })
    };
    AddressManageComponent.prototype.ngOnDestroy = function () {
        // this.editableSub.unsubscribe();
        this.mapSub.unsubscribe();
        this.removeAll();
    };
    return AddressManageComponent;
}());
export { AddressManageComponent };
// adhocSteps: ActionStep[] = [{
// 	num: 2,
// 	label: 'Select a road centerline.',
// 	prop: 'selectCenterline'
// },
// {
// 	num: 3,
// 	label: 'Place Address Points (double click to end)',
// 	prop: 'placeAddress'
// }];
// stackSteps: ActionStep[] = [{
// 	num: 2,
// 	label: 'Select a road centerline.',
// 	prop: 'selectCenterline'
// },
// // {
// // 	num: 2,
// // 	label: 'Number of stacked address',
// // 	isSameLine: true,
// // 	prop: 'numOfStacked'
// // },
// // {
// // 	num: 3,
// // 	label: 'Assigned Address',
// // 	isSameLine: true,
// // 	prop: 'assignedAddress'
// // },
// {
// 	num: 3,
// 	label: 'Sub-address Identification',
// 	prop: 'subAddress'
// }, {
// 	num: 4,
// 	label: 'Place stacked address on the map',
// 	prop: 'placeAddress'
// }];
// onChangeAssignmentType() {
// 	if (this.assignmentType && this.stepNum <= 2) {
// 		this.stepNum++;
// 		this.placeAddresses();
// 	}
// }
